module.exports = __webpack_public_path__ + "img/gzh_code.c1cb5971.png";